import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../lesson-02/lesson";
import lesson0403 from "../lesson-03/lesson";
import lesson0404 from "../lesson-04/lesson";
import lesson0406 from "../lesson-06/lesson";
import lesson0407 from "../lesson-07/lesson";
import lesson0409 from "../lesson-09/lesson";
import lesson0418 from "../lesson-18/lesson";
import lesson0419 from "../lesson-19/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "f7dfc944-370e-4d93-90e1-5279136283ed",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "cb850680-3a88-48c5-a38e-c400c3fca0a6",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "72de48fd-7f08-46ac-be6a-2b62ee8c0f2a",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0404),
    lesson: lesson0404,
  },
  {
    id: "28232d5a-0cae-4e4f-a1ff-9815c88608d9",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0406),
    lesson: lesson0406,
  },
  {
    id: "ce15a04e-c2aa-4988-9088-cc78d7cd4ff1",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
  {
    id: "582bc7f7-91fb-4100-a705-4bd3498c3537",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
  {
    id: "be75d644-136f-4ab4-aecf-0af18c368a66",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0418),
    lesson: lesson0418,
  },
  {
    id: "7c6a95ba-f445-47dd-9552-88a0441897b1",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
];

export default lessonLinks;
